export const CARBON_STRIP_LENGTH = 916;
export const VALID_CARBON_STRIP_LENGTH = 800;

export const WIRE_TYPE_COLOURS = {
    contact: "lime",
    catenary: "red",
    unclassified: "blue",
};
